<template>
  <div class="article-page">
    <div class="page-wrapper" v-if="article">
      <h1 class="h1">{{ article.title }}</h1>

      <div class="article-content">
        <div class="article-video">
          <vimeo
            :video-id="article.vimeo_id"
            ref="vimeo"
            class="vimeo-player"
          ></vimeo>
        </div>
        <div class="article-description" v-html="article.description"></div>
      </div>
    </div>
    <div v-else>
      <Spinner />
    </div>
  </div>
</template>

<script>
export default {
  name: "SchedulePage",
  metaInfo: {
    titleTemplate: "%s - Schedule",
  },
  data() {
    return {
      article: null,
    };
  },
  created() {
    this.setArticle();
  },
  methods: {
    async setArticle() {
      const { data } = await this.$api.Article.get({
        id: this.$route.params.id,
      });

      this.article = data;
    },
  },
};
</script>

<style scoped lang="scss">
.article-page {
  padding: 40px 0;
}

.article-content {
  padding: 40px 0;
}

.article-video {
  float: left;
  margin: 0 20px 20px 0;
}

.article-description {
}
</style>
